import { render, staticRenderFns } from "./AssetsLogin.vue?vue&type=template&id=3c46a4ec&scoped=true"
import script from "./AssetsLogin.vue?vue&type=script&lang=js"
export * from "./AssetsLogin.vue?vue&type=script&lang=js"
import style0 from "./AssetsLogin.vue?vue&type=style&index=0&id=3c46a4ec&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c46a4ec",
  null
  
)

export default component.exports